import React from 'react'
import PropTypes from 'prop-types'
import ChatConversationItemView from '../component/ChatConversationItemView'
import moment from 'moment'

const ChatConversationItem = props => {
  const {
    name,
    lastMessageTime,
    onConversationClick,
    onConversationArchive,
    isActive,
    lastMessageText,
    isCityBased,
    isUnread,
    archived,
  } = props

  const lastMessageTimeString = moment(lastMessageTime).format('HH:mm D MMM')

  return (
    <ChatConversationItemView
      name={name}
      lastMessageText={lastMessageText}
      lastMessageTime={lastMessageTimeString}
      onClick={onConversationClick}
      onArchive={onConversationArchive}
      isActive={isActive}
      isCityBased={isCityBased}
      isUnread={isUnread}
      archived={archived}
    />
  )
}

ChatConversationItem.propTypes = {
  name: PropTypes.string,
  lastMessage: PropTypes.string,
  lastMessageTime: PropTypes.number,
  onConversationClick: PropTypes.func,
  onConversationArchive: PropTypes.func,
  isActive: PropTypes.bool,
}

export default ChatConversationItem



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatConversationItem/container/ChatConversationItem.js